<template>
  <div data-locator="subscription-view">
    <transition name="app-fade">
      <div :key="$route.fullPath">
        <router-view v-slot="{ Component }">
          <component :is="Component" />
        </router-view>
      </div>
    </transition>
    <SubscriptionSidebar/>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

import { GET_SUBSCRIPTION } from '@/store/modules/subscription/action_types'
import SubscriptionSidebar from '@/subscriptions/SubscriptionSidebar.vue'

export default {
  name: 'Subscription',
  components: { SubscriptionSidebar },
  computed: {
    ...mapState('user', ['profile']),
    ...mapState('subscription', ['subscription']),
    ...mapGetters('user', ['canAccessSubscription']),
  },
  created () {
    if (!this.canAccessSubscription) {
      this.$router.replace('/')
    }
    this.prepareGetSubscription()
  },
  methods: {
    ...mapActions('subscription', [GET_SUBSCRIPTION]),
    prepareGetSubscription () {
      this.GET_SUBSCRIPTION(this.profile.subscription.id)
    },
  },
}
</script>
